import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('PAIRED_DEVICE');

export const FETCH_ALL = ActionType.RSAA('FETCH_ALL');
export const ACTIVATE = ActionType.RSAA('ACTIVATE');
export const REMOVE = ActionType.RSAA('REMOVE');
